import Vapi from 'vuex-rest-api';

// const credentials = {
//   user: 'test@test.cl',
//   pass: 'panwithchancho',
// }

const module = new Vapi({
  baseURL: process.env.API_URL ? process.env.API_URL : 'https://api.cryptocompra.com/',
  state: {
    auth: [],
  },
})
// prospects
.get({
    action: 'listProspects',
    property: 'prospects',
    path: '/prospects',
    queryParams: true,
})
// Merchants
.get({
    action: 'listMerchants',
    property: 'merchants',
    path: '/merchants?limit=100&sort=title',
    queryParams: true,
})
.get({
    action: 'getMerchant',
    property: 'merchant',
    path: '/merchants',
    queryParams: true
})
.get({
    action: 'getMerchantByDescription',
    property: 'merchant',
    path: '/merchants?limit=100&sort=title',
    queryParams: true,
})
.get({
    action: 'getCities',
    property: 'cities',
    path: '/cities?limit=100&sort=title',
    queryParams: true
})
.get({
    action: 'getCity',
    property: 'cities',
    path: '/cities',
    queryParams: true
})
.get({
    action: 'listCities',
    property: 'cities',
    path: '/cities?limit=100&sort=title',
    queryParams: true
})
.get({
    action: 'listCategories',
    property: 'categories',
    path: '/categories?limit=100&sort=title',
    queryParams: true
})
// .post({
//   action: "auth",
//   headers: {
//     'Authorization': 'Basic ' + btoa(credentials.user + ':' + credentials.pass)
//   },
//   property: "auth",
//   path: "/auth",
// })
.post({
    action: 'saveProspectForm',
    property: 'prospects',
    path: '/prospects',
})
// saveMerchant
.post({
    action: 'saveMerchant',
    property: 'merchants',
    path: '/merchants',
})
// saveCity
.post({
    action: 'saveCity',
    property: 'cities',
    path: '/cities',
})
// updateCity
.put({
    action: 'updateCity',
    property: 'cities',
    path: '/cities',
    path: ({ id }) => `/cities/${id}`
})
// updateMerchant
.put({
    action: 'updateMerchant',
    property: 'merchants',
    path: '/merchants',
    path: ({ id }) => `/merchants/${id}`
})
.getStore()

export default module;



// WEBPACK FOOTER //
// ./src/store/modules/api/module.js